import easydropdown from "easydropdown-a11y";
import "@styles/components/dropdown.css";
import { on } from "delegated-events";
import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import "@styles/components/slider.css";

const setupDropdown = (el) => {
  if (el.tagName !== "SELECT") {
    return;
  }

  const opts = {
    behavior: {
      openOnFocus: true,
      maxVisibleItems: 10,
      liveUpdates: true,
      useNativeUiOnMobile: false,
    },
    callbacks: {
      onSelect: (value) => handleFilter(el, value),
    },
  };

  easydropdown(el, opts);
};

document.querySelectorAll(".element-eventagenda").forEach((el) => {
  el.querySelectorAll(".agenda-filter").forEach((el) => setupDropdown(el));

  const list = el.querySelector(".swiper");

  new Swiper(list, {
    modules: [A11y, Navigation],
    slidesPerView: "auto",
    spaceBetween: 16,
    speed: 500,
    simulateTouch: false,
    threshold: 25,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
  });
});

on("change", '[name="agenda-filter"]', (e) => {
  handleFilter(e.target, e.target.value);
});

const handleFilter = (el, value) => {
  const parent = el.closest(".element-eventagenda");

  const days = parent.querySelectorAll("[data-day]");

  if (value === "all") {
    days.forEach((x) => x.classList.remove("hidden"));
  } else {
    days.forEach((x) => x.classList.add("hidden"));

    parent.querySelector(`[data-day="${value}"]`).classList.remove("hidden");
  }
};
